// Page to navigate to after saving campaign
// Query parameter signals that we shouldn't prompt before navigation - see <Prompt />
export const CAMPAIGN_PAGE_AFTER_SAVE_ROUTE =
  "/campaigns?campaign_unsaved=false";
